import { IoIosArrowForward } from 'react-icons/io';

import styled from 'styled-components';

import AirlineImg from 'components/AirlineLogo';
import FlightLine from 'components/FlightLine';

export const Flight = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;

  &:nth-child(2) {
    margin-top: 12px;
  }
`;

export const AirlineLogo = styled(AirlineImg)`
  width: 24px;
  margin-right: 10px;
  margin-top: -5px;
`;

export const Departure = styled.div`
  position: relative;
  width: 50px;
`;

export const Arrival = styled.div`
  position: relative;
  width: 50px;
  text-align: right;
`;

export const TurnDays = styled.span`
  position: absolute;
  right: -15px;
  top: -10px;
  width: 15px;
  font-size: 10px;
  text-align: left;
  color: ${({ theme }) => theme.cardFlight.primary};
`;

export const DepartureArrivalTime = styled.h5`
  font-weight: bold;
  color: #484d51;
`;

export const Airport = styled.span`
  font-size: 12px;
  color: #626e75;
`;

export const StopsLine = styled(FlightLine)`
  width: 60px;
`;

export const TapArea = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 10px;
  cursor: pointer;
`;

export const RightText = styled.div`
  text-align: right;
`;

export const AirlineName = styled.span`
  font-size: 12px;
  text-align: center;
  color: #626e75;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 75px;
`;

export const FlightLuggages = styled.div`
  & > img {
    margin: 0 1px;
  }
`;

export const Arrow = styled(IoIosArrowForward)`
  font-size: 14px;
  margin-left: 5px;
  color: ${({ theme }) => theme.cardFlight.primary} !important;
`;
